import React, { memo, useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { Button, Spinner } from '@xsolla/ui-core';

import { useConfig } from '../../../../contexts/config';
import { usePaths } from '../../../../routes/routesHelper';
import { SetupStepsType } from '../types';
import { Description, FetchingWrapper, StepWrapper, Title, Wrapper } from './styleBottomRow';

type Props = RouteComponentProps & {
  projectId: string;
  metricsName?: string;
};

const BottomRow = ({ projectId, metricsName, history }: Props): JSX.Element => {
  const { navigationPath } = usePaths();
  const intl = useIntl();
  const { xsollaAnalytics } = useConfig();

  const [steps, setSteps] = useState<SetupStepsType>({
    stepNumber: null,
    nextStep: null,
    fetching: false
  });

  const onButtonClick = useCallback(() => {
    xsollaAnalytics.sendClick(`login_pa_module__${metricsName}`, projectId);
    history.push({ pathname: navigationPath(projectId) });
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      setSteps({
        nextStep: 'Customize widget',
        stepNumber: null,
        fetching: false
      });
    }, Math.random() * 3000);

    return () => clearTimeout(t);
  }, [projectId]);

  if (steps.fetching) {
    return (
      <FetchingWrapper>
        <Spinner />
      </FetchingWrapper>
    );
  }

  if (steps.stepNumber) {
    return (
      <Wrapper>
        <Button palette="brand" onClick={onButtonClick}>
          {intl.formatMessage({ id: 'dashboard.login-card.steps.button' })}
        </Button>
        <StepWrapper>
          <Title>{intl.formatMessage({ id: 'dashboard.login-card.steps.label' })}</Title>
          <Description>{steps.nextStep}</Description>
        </StepWrapper>
        <StepWrapper>
          <Title>{intl.formatMessage({ id: 'dashboard.login-card.steps.completed' })}</Title>
          <Description>{`${steps.stepNumber}/10`}</Description>
        </StepWrapper>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Button
        data-test-id="btn-configure-project"
        palette="brand"
        look="tertiary"
        size="sm"
        onClick={onButtonClick}>
        {intl.formatMessage({ id: 'dashboard.login-card.button' })}
      </Button>
    </Wrapper>
  );
};

export default memo(withRouter(BottomRow));
